import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, Breadcrumb, InputGroup } from '@themesberg/react-bootstrap';
import Loader from 'components/Loader';
import { useDispatch } from 'react-redux';
import { apiCall, apiRoutes } from '../utils/helpers';
import { ProductTables } from 'components/Product/ProductTables';
import { ProductModal } from 'components/Product/ProductModal';

const ProductPage = () => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);

    const [editData, setEditData] = useState<any>();

    // student data update
    const handleClose = () => setShow(false);

    const editFunc = (editDataPayload: any) => {
        setEditData(editDataPayload);
        setShow(true);
    };

    const [searchWord, setSearchWord] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [dataState, setDataState] = useState<any>(null);

    const getDataFunc = async (params: any) => {
        const response = await apiCall({ ...apiRoutes.getProduct, params });
        if (response?.data?.status) {
            setDataState(response?.data);
            setIsLoading(false);
        }
    };

    const dispatchData = useCallback(
        async (pageNumber: number, searchingWord: string) => {
            const payload = {
                page: pageNumber,
                search_word: searchingWord,
            };
            await getDataFunc(payload);
        },
        [dispatch]
    );

    useEffect(() => {
        if (searchWord !== '') {
            setTimeout(() => {
                dispatchData(1, searchWord);
            }, 1000);
        }
    }, [dispatchData, searchWord]);

    useEffect(() => {
        dispatchData(1, '');
    }, [dispatchData]);

    return (
        <>
            {' '}
            {isLoading ? <Loader /> : null}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb
                        className="d-none d-md-inline-block"
                        listProps={{ className: 'breadcrumb-dark breadcrumb-transparent' }}
                    >
                        <Breadcrumb.Item>
                            <FontAwesomeIcon icon={faHome} />
                        </Breadcrumb.Item>

                        <Breadcrumb.Item active>Products</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Products</h4>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                        <Button onClick={() => setShow(true)} variant="outline-primary" size="sm">
                            Add
                        </Button>
                        {/* <Button variant="outline-primary" size="sm">Export</Button> */}
                    </ButtonGroup>
                </div>
            </div>
            <div className="table-settings mb-4">
                <Row className="justify-content-between align-items-center">
                    <Col xs={8} md={6} lg={3} xl={4}>
                        <InputGroup>
                            <InputGroup.Text>
                                <FontAwesomeIcon icon={faSearch} />
                            </InputGroup.Text>
                            <Form.Control
                                value={searchWord}
                                onChange={(e) => setSearchWord(e.target.value)}
                                type="text"
                                placeholder="Search"
                            />
                        </InputGroup>
                    </Col>
                </Row>
            </div>
            <ProductTables dataState={dataState} editFunc={editFunc} />
            {show && <ProductModal editData={editData} handleClose={handleClose} />}
        </>
    );
};

export default ProductPage;
